// Authentication service for JWT-based auth endpoints
import http from '@utils/http';
import { useAuthStore } from '@stores/auth.store';

export const login = async (email, password) => {
    const response = await http.post('/auth/login', { email, password });
    return response.data;
};

export const register = async (userData) => {
    const response = await http.post('/auth/register', userData);
    return response.data;
};

export const signup = async (payload) => {
    const response = await http.post('/auth/signup', payload);
    return response.data;
};

export const verifyEmail = async (payload) => {
    const response = await http.post('/auth/verify-email', payload);
    return response.data;
};

export const resendVerification = async (payload) => {
    const response = await http.post('/auth/resend-verification', payload);
    return response.data;
};

export const sendOtp = async (email) => {
    const response = await http.post('/auth/send-otp', { email });
    return response.data;
};

export const verifyOtp = async (email, otp) => {
    const response = await http.post('/auth/password/verify-otp', { email, otp });
    return response.data;
};

export const requestPasswordReset = async (email) => {
    const response = await http.post('/auth/password/request-reset', { email });
    return response.data;
};

export const resetPassword = async (email, otp, newPassword) => {
    const response = await http.post('/auth/password/reset', {
        email,
        otp,
        newPassword,
    });
    return response.data;
};

/** POST /api/v1/auth/accept-invitation – accept invite with name and new password */
export const acceptInvitation = async (payload) => {
    const response = await http.post('/auth/accept-invitation', payload);
    return response.data;
};

/** POST /api/v1/auth/accept-client-invitation – accept client invite with token, name, password; returns session */
export const acceptClientInvitation = async (payload) => {
    const response = await http.post('/auth/accept-client-invitation', payload);
    return response.data;
};

/** GET /api/v1/plans/public – list public plans for onboarding */
export const getPublicPlans = async () => {
    const response = await http.get('/plans/public');
    const list = response.data?.data ?? response.data?.data?.data ?? [];
    return Array.isArray(list) ? list : [];
};

/** POST /api/v1/auth/onboarding/client – sends access token from store (set after verify-email OTP) */
export const onboardingClient = async (payload) => {
    const accessToken = useAuthStore.getState().accessToken;
    const response = await http.post('/auth/onboarding/client', payload, {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });
    return response.data;
};

/** POST /api/v1/auth/onboarding/company – sends access token from store (set after verify-email OTP) */
export const onboardingCompany = async (payload) => {
    const accessToken = useAuthStore.getState().accessToken;
    const response = await http.post('/auth/onboarding/company', payload, {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });
    return response.data;
};
